function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */
var MotionValue = /*#__PURE__*/function () {
  function MotionValue() {
    _classCallCheck(this, MotionValue);
  }

  _createClass(MotionValue, [{
    key: "setAnimation",
    value: function setAnimation(animation) {
      var _this = this;

      this.animation = animation;
      animation === null || animation === void 0 ? void 0 : animation.finished.then(function () {
        return _this.clearAnimation();
      }).catch(function () {});
    }
  }, {
    key: "clearAnimation",
    value: function clearAnimation() {
      this.animation = this.generator = undefined;
    }
  }]);

  return MotionValue;
}();

export { MotionValue };